import ReactDOM from "react-dom";
const html2pdf = require("html2pdf.js");

export const downloadPDF = (component: any, id: any) => {
  // Create a new div element
  const element = document.createElement("div");
  element.id = "pdf-container";
  document.body.appendChild(element);

  ReactDOM.render(component, element, () => {
    const input = document.getElementById("pdf-container");

    if (input) {
      html2pdf()
        .from(input)
        .set({
          margin: 0.1,
          filename: `Invoice-${id}.pdf`,
          pagebreak: { mode: ["avoid-all", "css", "legacy"] },
          jsPDF: {
            orientation: "portrait",
            unit: "in",
            format: "letter",
            compressPDF: true,
          },
          image: { type: "jpeg", quality: 0.98 },
        })
        .save()
        .then(() => {
          ReactDOM.unmountComponentAtNode(element);
          document.body.removeChild(element);
        });
    }
  });
};
